// @ts-nocheck

import londonImage from "assets/images/background-banner/london.webp";
import newYorkImage from "assets/images/background-banner/new-york.webp";
import parisImage from "assets/images/background-banner/paris.webp";
import rioDeJaneiroImage from "assets/images/background-banner/rio-de-janeiro.webp";
import romeImage from "assets/images/background-banner/rome.webp";
import tokioImage from "assets/images/background-banner/tokio.webp";
import londonImageMobile from "assets/images/background-banner/london-mobile.webp";
import newYorkImageMobile from "assets/images/background-banner/new-york-mobile.webp";
import parisImageMobile from "assets/images/background-banner/paris-mobile.webp";
import rioDeJaneiroImageMobile from "assets/images/background-banner/rio-de-janeiro-mobile.webp";
import romeImageMobile from "assets/images/background-banner/rome-mobile.webp";
import tokioImageMobile from "assets/images/background-banner/tokio-mobile.webp";

export const imagesBackgroundBanner = [
  londonImage,
  newYorkImage,
  parisImage,
  rioDeJaneiroImage,
  romeImage,
  tokioImage,
  londonImageMobile,
  newYorkImageMobile,
  parisImageMobile,
  rioDeJaneiroImageMobile,
  romeImageMobile,
  tokioImageMobile,
];
